import fetch from "../fetch";

export default ({ userName, values }) => {
  return fetch({
    path: `/accounts/${userName ? `/${userName}` : ""}`,
    method: userName ? "PUT" : "POST",
    data: values
  });
};
